const helper = {
  getCurrentWeek: function getCurrentWeek() {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    // January 4 is always in week 1.
    let week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return `${date.getFullYear()}-W${
      1 +
      Math.round(
        ((date.getTime() - week1.getTime()) / 86400000 -
          3 +
          ((week1.getDay() + 6) % 7)) /
          7
      )
    }`;
  },
  getFormattedWeekDate: function getFormatedWeekDate(date, weekDay) {
    const dateDay = new Date(date).getDate();
    let dateMonth = new Date(date).getMonth() + 1;

    const weekDays = {
      0: "Monday",
      1: "Tuesday",
      2: "Wednesday",
      3: "Thursday",
      4: "Friday",
      5: "Saturday",
      6: "Sunday",
    };

    return `${weekDays[weekDay]}, ${dateDay}.${dateMonth}.`;
  },

  getDurationHeight: function getDurationHeight(duration) {
    return duration === 0
      ? { display: "none" }
      : { height: `${(duration / 1440) * 100}%` };
  },
  getFormattedTimeHelper: function getFormatedTimeHelper(time) {
    return time < 10 ? "0" + time : time;
  },

  getFormattedStartEnd: function getFormatedStartEnd(start, end) {
    const startDate = new Date(start);
    let startHours = startDate.getHours();
    let startMinutes = startDate.getMinutes();

    const endDate = new Date(end);
    let endHours = endDate.getHours();
    let endMinutes = endDate.getMinutes();

    return `${this.getFormattedTimeHelper(
      startHours
    )}:${this.getFormattedTimeHelper(
      startMinutes
    )} - ${this.getFormattedTimeHelper(endHours)}:${this.getFormattedTimeHelper(
      endMinutes
    )}`;
  },

  getDuration: function getDuration(start, end, first) {
    const startHour = parseInt(start.slice(0, 2));
    const endHour = end.slice(0, 2);

    if (startHour < 7 && endHour >= 7) {
      if (first) {
        start = "07:00";
      } else {
        end = "07:00";
      }
    }
    const startInMinutes =
      parseInt(start.slice(0, 2)) * 60 + parseInt(start.slice(3, 5));
    const endInMinutes =
      parseInt(end.slice(0, 2)) * 60 + parseInt(end.slice(3, 5));
    if (endInMinutes === startInMinutes) {
      return 0;
    }
    return endInMinutes > startInMinutes
      ? endInMinutes - startInMinutes
      : endInMinutes + 1440 - startInMinutes;
  },

  getDaysOfWeek: function getDaysOfWeek(week) {
    const year = week.slice(0, 4);
    const weekNumber = week.slice(6, 8);

    const firstDay = new Date(2015, 0, 1).getDay();

    let d = new Date("Jan 01, " + year + " 01:00:00");
    let w =
      d.getTime() - 3600000 * 24 * (firstDay + 1) + 604800000 * weekNumber;
    let mon = new Date(w);

    let tue = new Date(w + 86400000);
    let wed = new Date(w + 172800000);
    let thu = new Date(w + 259200000);
    let fri = new Date(w + 345600000);
    let sat = new Date(w + 432000000);
    let sun = new Date(w + 518400000);
    let nextMon = new Date(w + 604800000);

    return {
      0: {
        start: new Date(
          `${mon.getFullYear()}-${this.getZeroesOfDate(
            mon.getMonth() + 1
          )}-${this.getZeroesOfDate(mon.getDate())}T07:00:00`
        ),
        end: new Date(
          `${tue.getFullYear()}-${this.getZeroesOfDate(
            tue.getMonth() + 1
          )}-${this.getZeroesOfDate(tue.getDate())}T06:59:00`
        ),
      },
      1: {
        start: new Date(
          `${tue.getFullYear()}-${this.getZeroesOfDate(
            tue.getMonth() + 1
          )}-${this.getZeroesOfDate(tue.getDate())}T07:00:00`
        ),
        end: new Date(
          `${wed.getFullYear()}-${this.getZeroesOfDate(
            wed.getMonth() + 1
          )}-${this.getZeroesOfDate(wed.getDate())}T06:59:00`
        ),
      },
      2: {
        start: new Date(
          `${wed.getFullYear()}-${this.getZeroesOfDate(
            wed.getMonth() + 1
          )}-${this.getZeroesOfDate(wed.getDate())}T07:00:00`
        ),
        end: new Date(
          `${thu.getFullYear()}-${this.getZeroesOfDate(
            thu.getMonth() + 1
          )}-${this.getZeroesOfDate(thu.getDate())}T06:59:00`
        ),
      },
      3: {
        start: new Date(
          `${thu.getFullYear()}-${this.getZeroesOfDate(
            thu.getMonth() + 1
          )}-${this.getZeroesOfDate(thu.getDate())}T07:00:00`
        ),
        end: new Date(
          `${fri.getFullYear()}-${this.getZeroesOfDate(
            fri.getMonth() + 1
          )}-${this.getZeroesOfDate(fri.getDate())}T06:59:00`
        ),
      },
      4: {
        start: new Date(
          `${fri.getFullYear()}-${this.getZeroesOfDate(
            fri.getMonth() + 1
          )}-${this.getZeroesOfDate(fri.getDate())}T07:00:00`
        ),
        end: new Date(
          `${sat.getFullYear()}-${this.getZeroesOfDate(
            sat.getMonth() + 1
          )}-${this.getZeroesOfDate(sat.getDate())}T06:59:00`
        ),
      },
      5: {
        start: new Date(
          `${sat.getFullYear()}-${this.getZeroesOfDate(
            sat.getMonth() + 1
          )}-${this.getZeroesOfDate(sat.getDate())}T07:00:00`
        ),
        end: new Date(
          `${sun.getFullYear()}-${this.getZeroesOfDate(
            sun.getMonth() + 1
          )}-${this.getZeroesOfDate(sun.getDate())}T06:59:00`
        ),
      },
      6: {
        start: new Date(
          `${sun.getFullYear()}-${this.getZeroesOfDate(
            sun.getMonth() + 1
          )}-${this.getZeroesOfDate(sun.getDate())}T07:00:00`
        ),
        end: new Date(
          `${nextMon.getFullYear()}-${this.getZeroesOfDate(
            nextMon.getMonth() + 1
          )}-${this.getZeroesOfDate(nextMon.getDate())}T06:59:00`
        ),
      },
    };
  },

  getZeroesOfDate: function getZeroesOfDate(date) {
    return date < 10 ? "0" + date : date;
  },

  getChannelNameWithoutWhitespace: function getChannelNameWithoutWhitespace(
    channelname
  ) {
    return channelname.replace(/\s/g, "");
  },

  getWeekPDF: function getWeekPDF(week) {
    const yearStart = week[0].start.getFullYear();
    const yearEnd = week[6].start.getFullYear();
    const monthStart = week[0].start.getMonth() + 1;
    const monthEnd = week[6].start.getMonth() + 1;
    const dayStart = week[0].start.getDate();
    const dayEnd = week[6].start.getDate();

    /*
    const yearStart = week[0].start.slice(2, 4);
    const yearEnd = week[6].start.slice(2, 4);
    const monthStart = week[0].start.slice(5, 7);
    const monthEnd = week[6].start.slice(5, 7);
    const dayStart = week[0].start.slice(8, 10);
    const dayEnd = week[6].start.slice(8, 10);

 */

    //09.05.2022 - 15.05.2022
    return `${yearStart}.${monthStart}.${dayStart} - ${yearEnd}.${monthEnd}.${dayEnd}`;
  },

  getWeekStartEnd: function getWeekStartEnd(week) {
    const yearStart = week[0].start.getFullYear();
    const yearEnd = week[6].start.getFullYear();
    const monthStart = week[0].start.getMonth() + 1;
    const monthEnd = week[6].start.getMonth() + 1;
    const dayStart = week[0].start.getDate();
    const dayEnd = week[6].start.getDate();
    /*
    const yearStart = week[0].start.slice(0, 4);
    const yearEnd = week[6].start.slice(0, 4);
    const monthStart = week[0].start.slice(5, 7);
    const monthEnd = week[6].start.slice(5, 7);
    const dayStart = week[0].start.slice(8, 10);
    const dayEnd = week[6].start.slice(8, 10);

     */
    return `${dayStart}.${monthStart}.${yearStart} - ${dayEnd}.${monthEnd}.${yearEnd}`;
  },

  getFormattedDateString: function getFormattedDateString(date) {
    return `${date.getFullYear()}-${this.getFormattedTimeHelper(
      date.getMonth() + 1
    )}-${this.getFormattedTimeHelper(
      date.getDate()
    )}T${this.getFormattedTimeHelper(
      date.getHours()
    )}:${this.getFormattedTimeHelper(date.getMinutes())}:00Z`;
  },
};

export default helper;
